export default function ListEmptyCell() {
  return <div />;
}

ListEmptyCell.className = 'ListEmptyCell';
